module.exports = __webpack_public_path__ + "img/rincon-viamonte.f884f20f.jpg";